import { ConfigProvider, Form, Radio } from 'antd';
import { Input, Button, Typography } from "mobily-ui-library/lib";
import { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { GlobalContext } from '../../context/GlobalContext';
import './NotifyForm.scss';
import { sendOtp } from '../../api/api';
import { encrypt } from '../../utils';
import { captureData } from '../../api/api';
import { Calendar } from '../calendar/Calendar';
import CircleInfo from '../../assets/CircleInfo.svg';

const win: any = window;

interface Props {
    rtl: boolean;
}

function NotifyForm({ rtl }: Props) {
    const [form] = Form.useForm();
    const { t } = useTranslation();
    const direction = rtl ? 'rtl' : 'ltr';
    const { state, dispatch }: any = useContext(GlobalContext);
    const { CheckCoverageResponse, formData, postProductResponse, shoppingCart, requestFlow } = state;
    const subErrorCode = postProductResponse?.status?.subErrorCode;
    const [isFormValid, setIsFormValid] = useState(false);
    const [acceptTC, setAcceptTC] = useState(false);
    const [calendarValue, setCalendarValue] = useState<any>(formData?.calendarValue || new Date());

    const sections = shoppingCart?.context?.sections;
    const steps = sections?.[0]?.steps
    let isCustomerDetailsStep = true;
    let isLocationDetailsStep = true;
    if (requestFlow === 'installation') {
        isCustomerDetailsStep = steps ? steps.some((s: any) => s.stepId === 'CustomerDetails' && s.visible === true) : false;
        isLocationDetailsStep = steps ? steps.some((s: any) => s.stepId === 'LocationDetails' && s.visible === true) : false;
    }
    const location = `${state.center.lat}, ${state.center.lng}`;
    const coverageData = CheckCoverageResponse?.CSTZoneCoverage?.data ? CheckCoverageResponse.CSTZoneCoverage.data : {}

    const initialValues = {
        FirstName: formData?.FirstName,
        MiddleName: formData?.MiddleName,
        FamilyName: formData?.FamilyName,
        NationalId: formData?.NationalId,
        BirthDate: formData?.calendarValue?.format(),
        EmailAddress: formData?.EmailAddress,
        MobileNumber: formData?.MobileNumber,
        ShortNationalAddress: formData?.ShortNationalAddress,
        Street: formData?.Street,
        BuildingNumber: formData?.BuildingNumber,
        Coordinates: location,
        Region: coverageData?.region?.name ?? 'null',
        District: coverageData?.district?.name ?? 'null',
        City: coverageData?.city?.name ?? 'null',
        ZIPcode: coverageData?.zipCodeId ?? 'null',
        payOption: 'PayLater'
    }

    const onValuesChange = () => {
        setTimeout(() => {
            setIsFormValid((subErrorCode === 'E0000101' || form.isFieldsTouched(['FirstName', 'FamilyName', 'NationalId', 'BirthDate', 'EmailAddress', 'MobileNumber', 'ShortNationalAddress', 'Street', 'BuildingNumber'], true)) && form.getFieldsError().every(({ errors }) => errors.length === 0))
        }, 0);
    };

    useEffect(() => {
        const child = document.createElement('a');

        const inputElement: any = document.getElementsByClassName('buildingNumber_TextField');
        const childElement = inputElement[0]?.children[2]?.children[0];

        child.innerText = 'National Address | Saudi Post | SPL';
        child.setAttribute('href', 'https://splonline.com.sa/en/national-address-1/');
        child.setAttribute('target', '_blank');

        childElement.appendChild(child);

        return () => {
            childElement.removeChild(child);
        }
    }, []);

    useEffect(() => {
        dispatch({ type: 'SET_LOADER', payload: false });
    }, [dispatch]);


    useEffect(() => {
        if (subErrorCode === "E0000101") {
            form.setFields([
                {
                    name: 'ShortNationalAddress',
                    value: formData.ShortNationalAddress,
                    errors: [t('This_must_registered_under_Saudi_Post')],
                },
            ]);
        }
    }, [subErrorCode])

    const handleSubmitForm = async (values: any) => {
        try {
            dispatch({ type: 'SET_LOADER', payload: true });
            const options: any = { month: "2-digit", day: "2-digit", year: "numeric" };
            const formData = {
                ...values,
                RequestDate: new Date().toLocaleDateString("en-US", options).replace(/\//g, "/"),
                CheckCoverageResponse: JSON.stringify(CheckCoverageResponse),
                CoordinatesLongitude: state.center.lng,
                CoordinatesLatitude: state.center.lat,
                calendarValue: calendarValue,
                BirthDate: calendarValue?.format()
            }

            const excludeField = ['payOption', 'Coordinates', 'calendarValue'];
            const step0 = ['FirstName', 'MiddleName', 'FamilyName', 'NationalId', 'BirthDate', 'EmailAddress', 'MobileNumber']
            const fields0 = []
            const fields1 = []
            for (let key in formData) {
                if (!excludeField.includes(key)) {
                    if (step0.includes(key)) {
                        fields0.push({
                            name: key,
                            value: formData[key]
                        })
                    } else {
                        fields0.push({
                            name: key,
                            value: formData[key]
                        })
                        fields1.push({
                            name: key,
                            value: formData[key]
                        })
                    }
                }
            }
            sections[0].steps[0].fields = fields0
            if (requestFlow === 'installation') {
                sections[0].steps[1].fields = fields1
                sections[0].steps[2].fields = [{
                    name: 'PayType',
                    value: 'PayLater'
                }]
                sections[0].steps[3].fields = [{
                    name: 'ZoneCategory',
                    value: CheckCoverageResponse?.CSTZoneCoverage?.data?.serviceCategory ?? ''
                }]

                const updatedShoppingCart = {
                    ...shoppingCart,
                    context: {
                        ...shoppingCart.context,
                    },
                    sections
                }
                dispatch({ type: 'UPDATE_SHOPPING_CART', payload: updatedShoppingCart })
                const captureDataReq = structuredClone(updatedShoppingCart)
                const newSteps = captureDataReq.sections[0].steps;
                delete captureDataReq.context.sections
                let updatedSteps = newSteps.filter((s: any, index: any) => index !== 4);
                captureDataReq.sections[0] = { ...captureDataReq.sections[0], steps: updatedSteps }
                await captureData(captureDataReq)
                await getIntiateOTPCall(formData)
                window.scroll({ top: 0, left: 0, behavior: "smooth" });
            } else {
                const updatedShoppingCart = {
                    ...shoppingCart,
                    context: {
                        ...shoppingCart.context,
                    },
                    sections
                }
                await captureData(updatedShoppingCart)
                await getIntiateOTPCall(formData)
                window.scroll({ top: 0, left: 0, behavior: "smooth" });
            }
        } catch (err: any) {
            console.log(err, 'error')
            window.location.href = win['base_portal_url'] + win['errorPageURL'];
        }
    }

    const scrollToInput = () => {
        window.scrollTo({
            top: document.documentElement.scrollHeight * 0.1,
            behavior: 'smooth'
        });
    }

    const getIntiateOTPCall = (formData: any) => {
        const req = {
            "version": "v1",
            "journey": "PROFILE_INQUIRY",
            "operation": "PROFILE_TAHAQUQ_INQUIRY",
            "language": "en",
            "extraInfo": [
                {
                    "key": "MSISDN",
                    "value": encrypt(formData.MobileNumber)
                },
                {
                    "key": "PERSON_ID",
                    "value": encrypt(formData.NationalId)
                }
            ]
        }

        sendOtp(req)
            .then((res: any) => {
                if (res.status === 200 && res?.data?.status?.sourceCode === 'MAPI-000') {
                    dispatch({ type: 'SET_MSISDN', payload: { msisdn: res.data?.data?.msisdn, refId: res.data?.data?.refId, smsSentTo: res.data?.data?.smsSentTo } });
                    dispatch({ type: 'UPDATE_PAGE', payload: 'otp' });
                    dispatch({ type: 'FORM_DATA', payload: formData })
                } else if (res?.data?.status?.sourceCode === 'MAPI-6002') {
                    form.setFields([
                        {
                            name: 'MobileNumber',
                            value: formData.MobileNumber,
                            errors: [t('This_must_be_the_number_linked_to_your_national_ID_on_Absher')],
                        },
                    ]);
                    dispatch({ type: 'UPDATE_POPUP', payload: 'mismatchId' })
                    dispatch({ type: 'SET_LOADER', payload: false });
                    scrollToInput()
                } else if (res?.data?.status?.sourceCode === 'MAPI-6001') {
                    form.setFields([
                        {
                            name: 'NationalId',
                            value: formData.NationalId,
                            errors: [t('IDNumber_validation')],
                        },
                    ]);
                    dispatch({ type: 'SET_LOADER', payload: false });
                    scrollToInput()
                } else if (res?.data?.status?.sourceCode === 'MAPI-6003') {
                    form.setFields([
                        {
                            name: 'MobileNumber',
                            value: formData.MobileNumber,
                            errors: [t('MobileNumber_validation')],
                        },
                    ]);
                    dispatch({ type: 'SET_LOADER', payload: false });
                    scrollToInput()
                } else {
                    window.location.href = win['base_portal_url'] + win['errorPageURL'];
                }
            }).catch(err => {
                window.location.href = win['base_portal_url'] + win['errorPageURL'];
            })
    }

    const handleTermsCond = (e: any) => {
        setAcceptTC(e.target.checked)
    }

    return (
        <div className='Notify__Form'>
            <ConfigProvider direction={direction}>
                <Form form={form} name="control-ref" onFinish={handleSubmitForm} initialValues={initialValues} onValuesChange={onValuesChange}>
                    <div className='Notify__heading'>
                        <Typography rtl={rtl} className='title'>{t('Enter_details_for_installation')}</Typography>
                    </div>
                    {isCustomerDetailsStep && <div className='d-flex gap-4 flex-column'>
                        <Typography fontFamily='ScandiaWeb-Bold, ExpoArabic-Bold' rtl={rtl}>{t('Customer_details')}</Typography>
                        <div className='Notify__FormGroup'>
                            <Form.Item
                                hasFeedback
                                name='FirstName'
                                className={'form__fieldItem'}
                                rules={[
                                    { required: true, message: `${t('Please_enter')} ${t('First_name')}` },
                                    {
                                        message: t('FullName_validation'),
                                        pattern: /^[\u0621-\u064Aa-zA-Z][\u0621-\u064Aa-zA-Z\s]*$/
                                    },
                                    {
                                        message: t('FullName_exceed_length'),
                                        pattern: /^.{1,50}$/
                                    }
                                ]}
                            >
                                <Input
                                    rtl={rtl}
                                    placeholder={t('Enter_first_name')}
                                    headingleft={t('First_name')}
                                    className='receiverName_inputField'
                                />
                            </Form.Item>
                            <Form.Item
                                hasFeedback
                                name='MiddleName'
                                className={'form__fieldItem'}
                                rules={[
                                    {
                                        message: t('FullName_validation'),
                                        pattern: /^[\u0621-\u064Aa-zA-Z][\u0621-\u064Aa-zA-Z\s]*$/
                                    },
                                    {
                                        message: t('FullName_exceed_length'),
                                        pattern: /^.{0,50}$/
                                    }
                                ]}
                            >
                                <Input
                                    rtl={rtl}
                                    headingleft={t('Middle_name_optional')}
                                    className='receiverName_inputField'
                                />
                            </Form.Item>
                            <Form.Item
                                hasFeedback
                                name='FamilyName'
                                className={'form__fieldItem'}
                                rules={[
                                    { required: true, message: `${t('Please_enter')} ${t('Last_name')}` },
                                    {
                                        message: t('FullName_validation'),
                                        pattern: /^[\u0621-\u064Aa-zA-Z][\u0621-\u064Aa-zA-Z\s]*$/
                                    },
                                    {
                                        message: t('FullName_exceed_length'),
                                        pattern: /^.{1,50}$/
                                    }
                                ]}
                            >
                                <Input
                                    rtl={rtl}
                                    placeholder={t('Enter_last_name')}
                                    headingleft={t('Last_name')}
                                    className='receiverName_inputField'
                                />
                            </Form.Item>
                            <Form.Item
                                hasFeedback
                                name='NationalId'
                                className={'form__fieldItem'}
                                rules={[
                                    { required: true, message: `${t('Please_enter')} ${t('Saudi_ID_Iqama')}` },
                                    {
                                        message: t('IDNumber_validation'),
                                        pattern: /^[\u0661\u0662\u0031\u0032][\u0660-\u0669\u0030-\u0039]{0,9}$/
                                    }
                                ]}
                            >
                                <Input
                                    rtl={rtl}
                                    placeholder="XX XX XX XX XX"
                                    headingleft={t('Saudi_ID_Iqama')}
                                    maxLength={10}
                                />
                            </Form.Item>

                            <Form.Item
                                hasFeedback
                                name='BirthDate'
                                className={'form__fieldItem'}
                                rules={[
                                    { required: true, message: `${t('Please_enter')} ${t('DOB')}` },
                                ]}
                            >
                                <Calendar
                                    rtl={rtl}
                                    value={calendarValue}
                                    onChange={setCalendarValue}
                                    placeholder="MM/DD/YYYY"
                                    format='MM/DD/YYYY'
                                    headingLeft={t('DOB')}
                                    maxDate={new Date()}
                                />
                            </Form.Item>

                            <Form.Item
                                hasFeedback
                                name='EmailAddress'
                                className={'form__fieldItem'}
                                rules={[
                                    { required: true, message: t('Email_missing') },
                                    {
                                        message: t('Email_validation'),
                                        pattern: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/
                                    }
                                ]}
                            >
                                <Input
                                    rtl={rtl}
                                    placeholder="email@address.com"
                                    headingleft={t("Email_address")}
                                />
                            </Form.Item>
                            <Form.Item
                                hasFeedback
                                name='MobileNumber'
                                className={'form__fieldItem'}
                                rules={[
                                    { required: true, message: `${t('Please_enter')} ${t('Mobile_number')}` },
                                    {
                                        message: t('MobileNumber_validation'),
                                        pattern: /^((9665)([0-9]{8}))$/
                                    }
                                ]}
                            >
                                <Input
                                    rtl={rtl}
                                    placeholder='9665XXXXXXXX'
                                    headingleft={t('Mobile_number')}
                                    labelleft={t('This_must_number_linked')}
                                    maxLength={12}
                                />
                            </Form.Item>
                        </div>
                    </div>}
                    {isLocationDetailsStep && <div className='d-flex gap-4 flex-column'>
                        <Typography fontFamily='ScandiaWeb-Bold, ExpoArabic-Bold' rtl={rtl} className='mt-3'>{t('Location_details')}</Typography>
                        <div className='Notify__FormGroup'>
                            <Form.Item
                                hasFeedback
                                name='ShortNationalAddress'
                                className={'form__fieldItem'}
                                rules={[
                                    { required: true, message: `${t('Please_enter')} ${t('Short_National_Address')}` }
                                ]}
                            >
                                <Input
                                    rtl={rtl}
                                    placeholder={'XXXX'}
                                    headingleft={t('Short_National_Address')}
                                    labelleft={`${t('This_must_registered_under_Saudi_Post')}`}
                                />
                                {/* <div className='building-number-eg'>
                                    <img src={BuildingNumber} alt='Building Number Example' className='w-100 mt-2'/>
                                </div> */}
                            </Form.Item>
                            <Form.Item
                                hasFeedback
                                className={'form__fieldItem'}
                                rules={[{ required: false, message: `${t('Please_enter')} ${t('Coordinates')}` }]}
                                name="Coordinates"
                            >
                                <Input
                                    rtl={rtl}
                                    readOnly
                                    headingleft={t('Coordinates')}
                                    className='deliveryNotes_TextField readonly-input'
                                    value={location}
                                />
                            </Form.Item>

                            <Form.Item
                                hasFeedback
                                name='Region'
                                className={'form__fieldItem'}
                                rules={[
                                    { required: true, message: `${t('Please_enter')} ${t('Region')}` },
                                ]}
                            >
                                <Input
                                    readOnly
                                    rtl={rtl}
                                    placeholder={t('Enter_region')}
                                    headingleft={t("Region")}
                                    className='readonly-input'
                                />
                            </Form.Item>
                            <Form.Item
                                hasFeedback
                                name='City'
                                className={'form__fieldItem'}
                                rules={[
                                    { required: true, message: `${t('Please_enter')} ${t('City')}` },
                                ]}
                            >
                                <Input
                                    readOnly
                                    rtl={rtl}
                                    placeholder={t('Enter_city')}
                                    headingleft={t("City")}
                                    className='readonly-input'
                                />
                            </Form.Item>
                            <Form.Item
                                hasFeedback
                                name='District'
                                className={'form__fieldItem'}
                                rules={[
                                    { required: true, message: `${t('Please_enter')} ${t('District')}` },
                                ]}
                            >
                                <Input
                                    readOnly
                                    rtl={rtl}
                                    placeholder={t('Enter_district')}
                                    headingleft={t("District")}
                                    className='readonly-input'
                                />
                            </Form.Item>
                            <Form.Item
                                hasFeedback
                                name='Street'
                                className={'form__fieldItem'}
                                rules={[
                                    { required: true, message: `${t('Please_enter')} ${t('Street')}` },
                                ]}
                            >
                                <Input
                                    rtl={rtl}
                                    placeholder={t('Enter_street')}
                                    headingleft={t("Street")}
                                />
                            </Form.Item>
                            <Form.Item
                                hasFeedback
                                name='BuildingNumber'
                                className={'form__fieldItem'}
                                rules={[
                                    { required: true, message: `${t('Please_enter')} ${t('Building_number')}` },
                                    {
                                        message: t('Building_validation'),
                                        pattern: /^[0-9]{4}$/
                                    }
                                ]}
                            >
                                <Input
                                    rtl={rtl}
                                    placeholder={t('Enter_building_number')}
                                    headingleft={t('Building_number')}
                                    className='buildingNumber_TextField'
                                    labelleft={`${t('Building_number_details')}`}
                                    maxLength={4}
                                />
                            </Form.Item>

                            <Form.Item
                                hasFeedback
                                name='ZIPcode'
                                className={'form__fieldItem'}
                                rules={[{ required: false, message: `${t('Please_enter')} ${t('Zip_Code')}` }]}
                            >
                                <Input
                                    readOnly
                                    rtl={rtl}
                                    placeholder={t('Enter_zip_code')}
                                    headingleft={t('Zip_Code')}
                                    className='deliveryNotes_TextField readonly-input'
                                />
                            </Form.Item>
                        </div>
                    </div>}

                    <div className='form__StickyContainer'>
                        <div className={`Footer_Section ${requestFlow === 'installation' ? 'justify-content-between' : 'justify-content-center'}`}>
                            {requestFlow === 'installation' && (
                                <div className={rtl ? "form-check FS__TermNConR" : "form-check FS__TermNConL"}>
                                    <input
                                        className="STB__Checkbox"
                                        type="checkbox"
                                        id="termsCheckbox"
                                        onChange={handleTermsCond}
                                    />
                                    <div className='d-flex gap-1'>
                                        <label className="form-check-label text-dark" htmlFor="termsCheckbox">
                                            {t('I_agree_to_Mobily_shop')}
                                        </label>
                                        <a href={`${win['base_portal_url']}/web/en/general/ftthodbrequest/terms-and-conditions`} className="text-primary text-decoration-none" target="_blank" rel="noopener noreferrer">
                                            {t('Terms_Conditions')}
                                        </a>
                                    </div>
                                </div>
                            )}
                            <div className='FSTC__Box'>
                                <Button
                                    primary={true}
                                    rtl={rtl}
                                    variant={isFormValid && (requestFlow !== 'installation' || acceptTC) ? 'default' : 'disabled'}
                                    htmlType={'submit'}
                                    className='text-uppercase'
                                >
                                    {requestFlow === 'installation' ? t('Submit') : t('CONTINUE')}
                                </Button>
                            </div>
                        </div>
                    </div>
                </Form>
            </ConfigProvider>
        </div>
    )
}

export default NotifyForm